// 会话与访客ID工具

const SESSION_ID_KEY = 'session_id';
const VISITOR_ID_KEY = 'visitor_id';

export const getSessionId = (): string => {
  if (typeof window === 'undefined') return '';
  let sid = localStorage.getItem(SESSION_ID_KEY);
  if (!sid) {
    sid = `session_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_ID_KEY, sid);
  }
  return sid;
};

export const resetSessionId = (): string => {
  if (typeof window === 'undefined') return '';
  localStorage.removeItem(SESSION_ID_KEY);
  return getSessionId();
};

export const getVisitorId = (): string => {
  if (typeof window === 'undefined') return '';
  let vid = localStorage.getItem(VISITOR_ID_KEY);
  if (!vid) {
    vid = `visitor_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(VISITOR_ID_KEY, vid);
  }
  return vid;
};

export default { getSessionId, resetSessionId, getVisitorId };

